import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  numberedEnv,
  isNumberedEnv,
  sentryDsn,
  amplitudeAPIKey,
  muiProKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "dev",
  appRegion: "eu",
  appEnv: "eu-dev",
  displayAppEnv: "Dev EU",
  urls: {
    apiUrl: "https://core.api.dev.holobuilder.eu",
    baseUrl: "https://admin.dev.holobuilder.eu",
    dashboardUrl: "https://sphere.dev.holobuilder.eu",
    webEditorUrl: "https://app.dev.holobuilder.eu/app",
    entryPageUrl: "https://entry.dev.holobuilder.eu",
    adminPanelApi: "https://admin.dev.holobuilder.eu/api",
    cookieManagerUrl:
      "https://cookies.dev.holobuilder.eu/cookie-manager/manager/latest",
  },
  features: {
    muiProKey,
    amplitudeAPIKey,
  },
  keys: {
    sentryDsn,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu+dev@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
